module.exports = __webpack_public_path__ + "media/components/country-flag/static/bd-27a57f16d8ca05a9ac74071b91f114f5.svg";